import type { QueryClient } from '@tanstack/react-query';

const CHANNEX_QUERY_KEYS: string[][] = [
  ['calendar'],
  // Grundkalender und Preise-Reiter lesen das Verfügbarkeits-Readmodel.
  ['availability-distribution'],
  ['channex', 'ariPushHistory'],
  ['channex', 'syncActivity'],
  ['channex', 'ariState'],
];

/** Invalidiert alle Channex-abhängigen Ansichten, sobald eine Übertragung abgeschlossen ist. */
export function invalidateChannex(qc: QueryClient): Promise<unknown> {
  return Promise.all(CHANNEX_QUERY_KEYS.map((queryKey) => qc.invalidateQueries({ queryKey })));
}
